import { DateTime } from 'luxon';

import { Nullable } from '@/utils/types';

export function formatRelativeTime (date: Nullable<Date>): string {
  if (!date) return '';

  const dt = DateTime.fromJSDate(date);
  const now = DateTime.now();

  const diffInHours = now.diff(dt, 'hours').hours;
  const diffInDays = now.diff(dt, 'days').days;

  const hours = Math.floor(diffInHours);
  const days = Math.floor(diffInDays);

  if (hours < 1) return 'Just now';
  if (hours < 24) return `${hours}h ago`;
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;

  return dt.toLocaleString({ month: 'short', day: 'numeric' });
}
